<template>
	<div class="container__registers">
		<ContentHeader>
			<SubHeader :title="title" />
		</ContentHeader>
		<ContentBody>
			<Card :card-without-background="cardWithoutBackground">
				<router-view />
			</Card>
		</ContentBody>
	</div>
</template>

<script>
import Card from '../../components/Card/Card'
import ContentBody from '../../components/ContentBody/ContentBody'
import ContentHeader from '../../components/ContentHeader/ContentHeader'
import SubHeader from '../../components/SubHeader/SubHeader'

export default {
	components: { Card, ContentBody, ContentHeader, SubHeader },
	data: () => {
		return {
			activeRoute: '',
		}
	},
	computed: {
		title() {
			return `${this.$t('planning')} / ${this.label}`
		},
		label() {
			return this.labelAndLinkName.filter((f) => f.linkName === this.activeRoute)[0].label
		},
		// Telas que devem ter o efeito do card desligado
		cardWithoutBackground() {
			return ['ordemdeservicocubagem'].includes(this.activeRoute)
		},
		labelAndLinkName() {
			return [
				{ label: this.$t('serviceOrder'), linkName: 'ordemdeservico' },
				{ label: this.$t('collector'), linkName: 'coletor' },
				{ label: this.$t('cronogramaOrdemDeServico'), linkName: 'cronogramadeordemdeservico' },
			]
		},
	},
	watch: {
		$route(to) {
			this.activeRoute = to.name
		},
	},
	created() {
		this.activeRoute = this.$route.name
	},
}
</script>

<style scoped></style>
